const sounds = {
  // _comma: "_comma.wav",
  a: "a.wav",
  accelerating: "accelerating.wav",
  accelerator: "accelerator.wav",
  accepted: "accepted.wav",
  access: "access.wav",
  acknowledge: "acknowledge.wav",
  acknowledged: "acknowledged.wav",
  acquired: "acquired.wav",
  acquisition: "acquisition.wav",
  across: "across.wav",
  activate: "activate.wav",
  activated: "activated.wav",
  activity: "activity.wav",
  adios: "adios.wav",
  administration: "administration.wav",
  advanced: "advanced.wav",
  after: "after.wav",
  agent: "agent.wav",
  alarm: "alarm.wav",
  alert: "alert.wav",
  alien: "alien.wav",
  aligned: "aligned.wav",
  all: "all.wav",
  alpha: "alpha.wav",
  am: "am.wav",
  amigo: "amigo.wav",
  ammunition: "ammunition.wav",
  an: "an.wav",
  and: "and.wav",
  announcement: "announcement.wav",
  anomalous: "anomalous.wav",
  antenna: "antenna.wav",
  any: "any.wav",
  apprehend: "apprehend.wav",
  approach: "approach.wav",
  are: "are.wav",
  area: "area.wav",
  arm: "arm.wav",
  armed: "armed.wav",
  armor: "armor.wav",
  armory: "armory.wav",
  arrest: "arrest.wav",
  ass: "ass.wav",
  at: "at.wav",
  atomic: "atomic.wav",
  attention: "attention.wav",
  authorize: "authorize.wav",
  authorized: "authorized.wav",
  automatic: "automatic.wav",
  away: "away.wav",
  b: "b.wav",
  back: "back.wav",
  backman: "backman.wav",
  bad: "bad.wav",
  bag: "bag.wav",
  bailey: "bailey.wav",
  barracks: "barracks.wav",
  base: "base.wav",
  bay: "bay.wav",
  be: "be.wav",
  been: "been.wav",
  before: "before.wav",
  beyond: "beyond.wav",
  biohazard: "biohazard.wav",
  biological: "biological.wav",
  birdwell: "birdwell.wav",
  bizwarn: "bizwarn.wav",
  black: "black.wav",
  blast: "blast.wav",
  blocked: "blocked.wav",
  bloop: "bloop.wav",
  blue: "blue.wav",
  boomer: "boomer.wav",
  bottom: "bottom.wav",
  bravo: "bravo.wav",
  breach: "breach.wav",
  breached: "breached.wav",
  break: "break.wav",
  bridge: "bridge.wav",
  bust: "bust.wav",
  but: "but.wav",
  button: "button.wav",
  buzwarn: "buzwarn.wav",
  bypass: "bypass.wav",
  c: "c.wav",
  cable: "cable.wav",
  call: "call.wav",
  called: "called.wav",
  canal: "canal.wav",
  cap: "cap.wav",
  captain: "captain.wav",
  capture: "capture.wav",
  captured: "captured.wav",
  ceiling: "ceiling.wav",
  celsius: "celsius.wav",
  center: "center.wav",
  centi: "centi.wav",
  central: "central.wav",
  chamber: "chamber.wav",
  charlie: "charlie.wav",
  check: "check.wav",
  checkpoint: "checkpoint.wav",
  chemical: "chemical.wav",
  cleanup: "cleanup.wav",
  clear: "clear.wav",
  clearance: "clearance.wav",
  close: "close.wav",
  code: "code.wav",
  coded: "coded.wav",
  collider: "collider.wav",
  command: "command.wav",
  communication: "communication.wav",
  complex: "complex.wav",
  computer: "computer.wav",
  condition: "condition.wav",
  containment: "containment.wav",
  contamination: "contamination.wav",
  control: "control.wav",
  coolant: "coolant.wav",
  coomer: "coomer.wav",
  core: "core.wav",
  correct: "correct.wav",
  corridor: "corridor.wav",
  crew: "crew.wav",
  cross: "cross.wav",
  cryogenic: "cryogenic.wav",
  d: "d.wav",
  dadeda: "dadeda.wav",
  damage: "damage.wav",
  damaged: "damaged.wav",
  danger: "danger.wav",
  day: "day.wav",
  deactivated: "deactivated.wav",
  decompression: "decompression.wav",
  decontamination: "decontamination.wav",
  deeoo: "deeoo.wav",
  defense: "defense.wav",
  degrees: "degrees.wav",
  delta: "delta.wav",
  denied: "denied.wav",
  deploy: "deploy.wav",
  deployed: "deployed.wav",
  destroy: "destroy.wav",
  destroyed: "destroyed.wav",
  detain: "detain.wav",
  detected: "detected.wav",
  detonation: "detonation.wav",
  device: "device.wav",
  did: "did.wav",
  die: "die.wav",
  dimensional: "dimensional.wav",
  dirt: "dirt.wav",
  disengaged: "disengaged.wav",
  dish: "dish.wav",
  disposal: "disposal.wav",
  distance: "distance.wav",
  distortion: "distortion.wav",
  do: "do.wav",
  doctor: "doctor.wav",
  doop: "doop.wav",
  door: "door.wav",
  down: "down.wav",
  dual: "dual.wav",
  duct: "duct.wav",
  e: "e.wav",
  east: "east.wav",
  echo: "echo.wav",
  ed: "ed.wav",
  effect: "effect.wav",
  egress: "egress.wav",
  eight: "eight.wav",
  eighteen: "eighteen.wav",
  eighty: "eighty.wav",
  electric: "electric.wav",
  electromagnetic: "electromagnetic.wav",
  elevator: "elevator.wav",
  eleven: "eleven.wav",
  eliminate: "eliminate.wav",
  emergency: "emergency.wav",
  endgame: "endgame.wav",
  enemy: "enemy.wav",
  energy: "energy.wav",
  engage: "engage.wav",
  engaged: "engaged.wav",
  engine: "engine.wav",
  enter: "enter.wav",
  entry: "entry.wav",
  environment: "environment.wav",
  error: "error.wav",
  escape: "escape.wav",
  evacuate: "evacuate.wav",
  exchange: "exchange.wav",
  exit: "exit.wav",
  expect: "expect.wav",
  experiment: "experiment.wav",
  experimental: "experimental.wav",
  explode: "explode.wav",
  explosion: "explosion.wav",
  exposure: "exposure.wav",
  exterminate: "exterminate.wav",
  extinguish: "extinguish.wav",
  extinguisher: "extinguisher.wav",
  extreme: "extreme.wav",
  f: "f.wav",
  facility: "facility.wav",
  fahrenheit: "fahrenheit.wav",
  failed: "failed.wav",
  failure: "failure.wav",
  farthest: "farthest.wav",
  fast: "fast.wav",
  feet: "feet.wav",
  field: "field.wav",
  fifteen: "fifteen.wav",
  fifth: "fifth.wav",
  fifty: "fifty.wav",
  final: "final.wav",
  fine: "fine.wav",
  fire: "fire.wav",
  first: "first.wav",
  five: "five.wav",
  flag: "flag.wav",
  flooding: "flooding.wav",
  floor: "floor.wav",
  fool: "fool.wav",
  for: "for.wav",
  forbidden: "forbidden.wav",
  force: "force.wav",
  forms: "forms.wav",
  found: "found.wav",
  four: "four.wav",
  fourteen: "fourteen.wav",
  fourth: "fourth.wav",
  fourty: "fourty.wav",
  foxtrot: "foxtrot.wav",
  freeman: "freeman.wav",
  freezer: "freezer.wav",
  from: "from.wav",
  front: "front.wav",
  fuel: "fuel.wav",
  g: "g.wav",
  gas: "gas.wav",
  get: "get.wav",
  go: "go.wav",
  going: "going.wav",
  good: "good.wav",
  goodbye: "goodbye.wav",
  gordon: "gordon.wav",
  got: "got.wav",
  government: "government.wav",
  granted: "granted.wav",
  great: "great.wav",
  green: "green.wav",
  grenade: "grenade.wav",
  guard: "guard.wav",
  gulf: "gulf.wav",
  gun: "gun.wav",
  guthrie: "guthrie.wav",
  handling: "handling.wav",
  hangar: "hangar.wav",
  has: "has.wav",
  have: "have.wav",
  hazard: "hazard.wav",
  head: "head.wav",
  health: "health.wav",
  heat: "heat.wav",
  helicopter: "helicopter.wav",
  helium: "helium.wav",
  hello: "hello.wav",
  help: "help.wav",
  here: "here.wav",
  hide: "hide.wav",
  high: "high.wav",
  highest: "highest.wav",
  hit: "hit.wav",
  holds: "holds.wav",
  hole: "hole.wav",
  hostile: "hostile.wav",
  hot: "hot.wav",
  hotel: "hotel.wav",
  hour: "hour.wav",
  hours: "hours.wav",
  hundred: "hundred.wav",
  hydro: "hydro.wav",
  i: "i.wav",
  idiot: "idiot.wav",
  illegal: "illegal.wav",
  immediate: "immediate.wav",
  immediately: "immediately.wav",
  in: "in.wav",
  inches: "inches.wav",
  india: "india.wav",
  ing: "ing.wav",
  inoperative: "inoperative.wav",
  inside: "inside.wav",
  inspection: "inspection.wav",
  inspector: "inspector.wav",
  interchange: "interchange.wav",
  intruder: "intruder.wav",
  invallid: "invallid.wav",
  invasion: "invasion.wav",
  is: "is.wav",
  it: "it.wav",
  johnson: "johnson.wav",
  juliet: "juliet.wav",
  key: "key.wav",
  kill: "kill.wav",
  kilo: "kilo.wav",
  kit: "kit.wav",
  lab: "lab.wav",
  lambda: "lambda.wav",
  laser: "laser.wav",
  last: "last.wav",
  launch: "launch.wav",
  leak: "leak.wav",
  leave: "leave.wav",
  left: "left.wav",
  legal: "legal.wav",
  level: "level.wav",
  lever: "lever.wav",
  lie: "lie.wav",
  lieutenant: "lieutenant.wav",
  life: "life.wav",
  light: "light.wav",
  lima: "lima.wav",
  liquid: "liquid.wav",
  loading: "loading.wav",
  locate: "locate.wav",
  located: "located.wav",
  location: "location.wav",
  lock: "lock.wav",
  locked: "locked.wav",
  locker: "locker.wav",
  lockout: "lockout.wav",
  lower: "lower.wav",
  lowest: "lowest.wav",
  magnetic: "magnetic.wav",
  main: "main.wav",
  maintenance: "maintenance.wav",
  malfunction: "malfunction.wav",
  man: "man.wav",
  mass: "mass.wav",
  materials: "materials.wav",
  maximum: "maximum.wav",
  may: "may.wav",
  medical: "medical.wav",
  men: "men.wav",
  mercy: "mercy.wav",
  mesa: "mesa.wav",
  message: "message.wav",
  meter: "meter.wav",
  micro: "micro.wav",
  middle: "middle.wav",
  mike: "mike.wav",
  miles: "miles.wav",
  military: "military.wav",
  milli: "milli.wav",
  million: "million.wav",
  minefield: "minefield.wav",
  minimum: "minimum.wav",
  minutes: "minutes.wav",
  mister: "mister.wav",
  mode: "mode.wav",
  motor: "motor.wav",
  motorpool: "motorpool.wav",
  move: "move.wav",
  must: "must.wav",
  nearest: "nearest.wav",
  nerve: "nerve.wav",
  nice: "nice.wav",
  nine: "nine.wav",
  nineteen: "nineteen.wav",
  ninety: "ninety.wav",
  no: "no.wav",
  nominal: "nominal.wav",
  north: "north.wav",
  not: "not.wav",
  november: "november.wav",
  now: "now.wav",
  number: "number.wav",
  objective: "objective.wav",
  observation: "observation.wav",
  of: "of.wav",
  officer: "officer.wav",
  ok: "ok.wav",
  on: "on.wav",
  one: "one.wav",
  open: "open.wav",
  operating: "operating.wav",
  operations: "operations.wav",
  operative: "operative.wav",
  option: "option.wav",
  order: "order.wav",
  organic: "organic.wav",
  oscar: "oscar.wav",
  out: "out.wav",
  outside: "outside.wav",
  over: "over.wav",
  overload: "overload.wav",
  override: "override.wav",
  pacify: "pacify.wav",
  pain: "pain.wav",
  pal: "pal.wav",
  panel: "panel.wav",
  percent: "percent.wav",
  perimeter: "perimeter.wav",
  period: "period.wav",
  permitted: "permitted.wav",
  personnel: "personnel.wav",
  pipe: "pipe.wav",
  plant: "plant.wav",
  platform: "platform.wav",
  please: "please.wav",
  point: "point.wav",
  portal: "portal.wav",
  power: "power.wav",
  presence: "presence.wav",
  press: "press.wav",
  primary: "primary.wav",
  proceed: "proceed.wav",
  processing: "processing.wav",
  progress: "progress.wav",
  proper: "proper.wav",
  propulsion: "propulsion.wav",
  prosecute: "prosecute.wav",
  protective: "protective.wav",
  push: "push.wav",
  quantum: "quantum.wav",
  quebec: "quebec.wav",
  question: "question.wav",
  questioning: "questioning.wav",
  quick: "quick.wav",
  quit: "quit.wav",
  radiation: "radiation.wav",
  radioactive: "radioactive.wav",
  rads: "rads.wav",
  rapid: "rapid.wav",
  reach: "reach.wav",
  reached: "reached.wav",
  reactor: "reactor.wav",
  red: "red.wav",
  relay: "relay.wav",
  released: "released.wav",
  remaining: "remaining.wav",
  renegade: "renegade.wav",
  repair: "repair.wav",
  report: "report.wav",
  reports: "reports.wav",
  required: "required.wav",
  research: "research.wav",
  reset: "reset.wav",
  resevoir: "resevoir.wav",
  resistance: "resistance.wav",
  returned: "returned.wav",
  right: "right.wav",
  rocket: "rocket.wav",
  roger: "roger.wav",
  romeo: "romeo.wav",
  room: "room.wav",
  round: "round.wav",
  run: "run.wav",
  safe: "safe.wav",
  safety: "safety.wav",
  sargeant: "sargeant.wav",
  satellite: "satellite.wav",
  save: "save.wav",
  science: "science.wav",
  scores: "scores.wav",
  scream: "scream.wav",
  screen: "screen.wav",
  search: "search.wav",
  second: "second.wav",
  secondary: "secondary.wav",
  seconds: "seconds.wav",
  sector: "sector.wav",
  secure: "secure.wav",
  secured: "secured.wav",
  security: "security.wav",
  select: "select.wav",
  selected: "selected.wav",
  service: "service.wav",
  seven: "seven.wav",
  seventeen: "seventeen.wav",
  seventy: "seventy.wav",
  severe: "severe.wav",
  sewage: "sewage.wav",
  sewer: "sewer.wav",
  shield: "shield.wav",
  shipment: "shipment.wav",
  shock: "shock.wav",
  shoot: "shoot.wav",
  shower: "shower.wav",
  shut: "shut.wav",
  side: "side.wav",
  sierra: "sierra.wav",
  sight: "sight.wav",
  silo: "silo.wav",
  six: "six.wav",
  sixteen: "sixteen.wav",
  sixty: "sixty.wav",
  slime: "slime.wav",
  slow: "slow.wav",
  soldier: "soldier.wav",
  some: "some.wav",
  someone: "someone.wav",
  something: "something.wav",
  son: "son.wav",
  sorry: "sorry.wav",
  south: "south.wav",
  squad: "squad.wav",
  square: "square.wav",
  stairway: "stairway.wav",
  status: "status.wav",
  sterile: "sterile.wav",
  sterilization: "sterilization.wav",
  stolen: "stolen.wav",
  storage: "storage.wav",
  sub: "sub.wav",
  subsurface: "subsurface.wav",
  sudden: "sudden.wav",
  suit: "suit.wav",
  superconducting: "superconducting.wav",
  supercooled: "supercooled.wav",
  supply: "supply.wav",
  surface: "surface.wav",
  surrender: "surrender.wav",
  surround: "surround.wav",
  surrounded: "surrounded.wav",
  switch: "switch.wav",
  system: "system.wav",
  systems: "systems.wav",
  tactical: "tactical.wav",
  take: "take.wav",
  talk: "talk.wav",
  tango: "tango.wav",
  tank: "tank.wav",
  target: "target.wav",
  team: "team.wav",
  temperature: "temperature.wav",
  temporal: "temporal.wav",
  ten: "ten.wav",
  terminal: "terminal.wav",
  terminated: "terminated.wav",
  termination: "termination.wav",
  test: "test.wav",
  that: "that.wav",
  the: "the.wav",
  then: "then.wav",
  there: "there.wav",
  third: "third.wav",
  thirteen: "thirteen.wav",
  thirty: "thirty.wav",
  this: "this.wav",
  those: "those.wav",
  thousand: "thousand.wav",
  threat: "threat.wav",
  three: "three.wav",
  through: "through.wav",
  time: "time.wav",
  to: "to.wav",
  top: "top.wav",
  topside: "topside.wav",
  touch: "touch.wav",
  towards: "towards.wav",
  track: "track.wav",
  train: "train.wav",
  transportation: "transportation.wav",
  truck: "truck.wav",
  tunnel: "tunnel.wav",
  turn: "turn.wav",
  turret: "turret.wav",
  twelve: "twelve.wav",
  twenty: "twenty.wav",
  two: "two.wav",
  unauthorized: "unauthorized.wav",
  under: "under.wav",
  uniform: "uniform.wav",
  unlocked: "unlocked.wav",
  until: "until.wav",
  up: "up.wav",
  upper: "upper.wav",
  uranium: "uranium.wav",
  us: "us.wav",
  usa: "usa.wav",
  use: "use.wav",
  used: "used.wav",
  user: "user.wav",
  vacate: "vacate.wav",
  valid: "valid.wav",
  vapor: "vapor.wav",
  vent: "vent.wav",
  ventillation: "ventillation.wav",
  victor: "victor.wav",
  violated: "violated.wav",
  violation: "violation.wav",
  voltage: "voltage.wav",
  vox_login: "vox_login.wav",
  walk: "walk.wav",
  wall: "wall.wav",
  want: "want.wav",
  wanted: "wanted.wav",
  warm: "warm.wav",
  warn: "warn.wav",
  warning: "warning.wav",
  waste: "waste.wav",
  water: "water.wav",
  we: "we.wav",
  weapon: "weapon.wav",
  west: "west.wav",
  whiskey: "whiskey.wav",
  white: "white.wav",
  wilco: "wilco.wav",
  will: "will.wav",
  with: "with.wav",
  without: "without.wav",
  woop: "woop.wav",
  xeno: "xeno.wav",
  yankee: "yankee.wav",
  yards: "yards.wav",
  year: "year.wav",
  yellow: "yellow.wav",
  yes: "yes.wav",
  you: "you.wav",
  your: "your.wav",
  yourself: "yourself.wav",
  zero: "zero.wav",
  zone: "zone.wav",
  zulu: "zulu.wav",
};

function playWord(word) {
  return new Promise((resolve, reject) => {
    const audio = document.createElement("audio");
    audio.style.display = "none";
    document.body.appendChild(audio);

    audio.src = "/vox/" + sounds[word];

    audio.ontimeupdate = (ev) => {
      if (audio.currentTime === audio.duration) {
        audio.pause();
        if (audio.parentNode != null) {
          audio.parentNode.removeChild(audio);
        }
        resolve();
      }
    };

    audio.onerror = (err) => {
      console.error(err);
      document.body.removeChild(audio);
      resolve();
    };

    audio.play();
  });
}

const vox = {
  words: Object.keys(sounds),
  playWord(word) {
    return playWord(word);
  },
  async playSentence(words) {
    // False positive in eslint rule???
    // eslint-disable-next-line no-unused-vars
    for (let word of words) {
      await playWord(word);
    }
  },
};

export default vox;
